import React from 'react';
import isEmpty from 'lodash/isEmpty';
import {FormattedMessage} from 'react-intl';
import {any, arrayOf, func, object} from 'prop-types';
import {Form, Button, Icon, Label} from 'semantic-ui-react';
import ContentEditable from 'components/forms/BasicFormFields/ContentEditable';
import {isNoU, parseContentEditable} from 'utils/DBUtils';

// this is *mostly* the same as AutoSaveContentEditable, sans auto-save and with other minor tweaks.
export default class ContentEditableInput extends React.Component {
  static propTypes = {
    value: any,
    errors: arrayOf(object),
    onValueChanged: func.isRequired
  };

  static defaultProps = {
    errors: []
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      valueLength: isNoU(props.value) ? 0 : parseContentEditable(props.value).length
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    // don't reset the current value when there are failed validations.
    if (nextProps.value !== this.props.value && isEmpty(nextProps.errors)) {
      this.setState({
        value: nextProps.value,
        valueLength: isNoU(nextProps.value) ? 0 : parseContentEditable(nextProps.value).length
      });
    }
  }

  getValueFromOnChange = (event) => {
    return event.target.value;
  };

  updateTextLength = (length) => {
    this.setState({valueLength: length});
  };

  promptLink = () => {
    const selection = window.getSelection();
    const textWasSelected = selection.focusOffset !== selection.anchorOffset;

    if (textWasSelected) {
      const url = prompt('Enter a URL: ', 'http://');
      const title = selection.toString();

      if (!isEmpty(url) && !url.match(/^https?:\/\/$/)) {
        const link = `<a href=${encodeURI(url)} target="_blank" rel="noopener">${title}</a>`;
        document.execCommand('insertHTML', false, link);
      }
    }
  };

  onValueChange = event => {
    const {value} = event.target;
    this.setState({value});

    let doc = new DOMParser().parseFromString(value, 'text/html');

    // Content editable is inserting styles when making and merging paragraphs
    // this is a quick solution, ideally we merge all span text into the parent paragraph
    let withStyles = doc.querySelectorAll('span[style]');
    for (let span of withStyles) {
      span.removeAttribute('style');
    }

    let cleanValue = doc.querySelector('body').innerHTML;
    cleanValue = cleanValue.replaceAll("<p></p>", "")
    cleanValue = cleanValue.replaceAll("<div><br></div>", "<br>")
    cleanValue = cleanValue.replaceAll("<br>", "<br/>")
    cleanValue = cleanValue.replaceAll("&nbsp;", " ")
    this.props.onValueChanged(cleanValue);
  };

  execCommand = commandName => () => {
    document.execCommand(commandName);
  };

  render() {
    return (
      <Form.Field className='content-editable-field'>
        {this.props.label}
        <ContentEditable
          html={this.state.value}
          onChange={this.onValueChange}
          getTextLengthCallback={this.updateTextLength} />
        <div className='formatting-buttons'>
          <Button onClick={this.execCommand('bold')}>
            <Icon name='bold' />
          </Button>
          <Button onClick={this.execCommand('italic')}>
            <Icon name='italic' />
          </Button>
          <Button onClick={this.execCommand('underline')}>
            <Icon name='underline' />
          </Button>
          <Button onClick={this.execCommand('insertOrderedList')}>
            <Icon name='ordered list' />
          </Button>
          <Button onClick={this.execCommand('insertUnorderedList')}>
            <Icon name='unordered list' />
          </Button>
          <Button onClick={this.execCommand('strikethrough')}>
            <Icon name='strikethrough' />
          </Button>
          <Button onClick={this.execCommand('superscript')}>
            <Icon name='superscript' />
          </Button>
          <Button onClick={this.execCommand('subscript')}>
            <Icon name='subscript' />
          </Button>
          <Button onClick={this.promptLink}>
            <Icon name='linkify' />
          </Button>
          <Button onClick={this.execCommand('unlinkify')}>
            <Icon name='unlinkify' />
          </Button>
        </div>
        {this.props.errors.map(error => (
          <Label
            basic
            className='db-error-label'
            key={error.type}>
            <FormattedMessage id={`errors.validation.${error.type}`} />&nbsp;
            {error.invalidValues && (
              <FormattedMessage
                id='errors.validation.invalid_values'
                values={{invalidValues: error.invalidValues}} />
            )}
          </Label>
        ))}
      </Form.Field>
    );
  }
};



// WEBPACK FOOTER //
// ./public/components/forms/BasicFormFields/ContentEditableInput.jsx